<div class="loader-wrapper" *ngIf="!isLoaded; else generatedCode">
  <app-loader></app-loader>
</div>
<ng-template #generatedCode>
  <div class="generated-code-container">
    <div class="generated-code-header">
      <h3>{{ 'view_translations.generated_code' | translate }}</h3>
      <h4>{{ 'view_translations.generated_code_info' | translate }}</h4>
    </div>
    <div class="copy-button" (click)="copyInputMessage()">
      <nb-icon class="copy-icon" icon="copy" pack="icomoon"></nb-icon>
    </div>
    <pre><code [highlight]="bannerCode" [lineNumbers]="false"></code></pre>
  </div>
</ng-template>
